export default "__VITE_ASSET__nCcxReZK__"